import React, {useEffect, useState} from 'react'
import { Card, Col, Row } from 'react-bootstrap';
import ImageViewer from '../../common/ImageViewer';

const MultiItemSlider = (props) => {
    const [topvalue, setTopvalue] = useState(null);
    const [middlevalue, setMiddlevalue] = useState();
    const [bottomvalue, setBottomvalue] = useState();

    const [modalShow, setModalShow] = useState(false);
    const [imageUrl, setImageUrl] = useState(null)

    const openImageModal = (data, imageArray) => {
        setModalShow(true)
        setImageUrl(data)
    }

    const shuffle = arr => [...arr].sort(() => Math.random() - 0.5);
    const l1 = []
    const l2 = []
    const l3 = []

    const lists = (v1, v2) => {
        let data = [];
        for (let index = v1; index < v2; index++) {
             data.push(index);
        }
         return data;
    }

    if(topvalue){
        topvalue.forEach((data, value) => {
            // console.log(data)
            l1.push(<img id={data} src={"/assets/home-goods/images/" + data +".jpg"} alt={data} className='image-slider-auto mx-4' onClick={() => openImageModal(data, topvalue)} key={value} />)
        })
    }

    if(middlevalue){
        middlevalue.forEach((data, value) => {
            l2.push(<img id={data} src={"/assets/home-goods/images/" + data +".jpg"} alt={data} className='image-slider-auto mx-4' onClick={() => openImageModal(data, middlevalue)} key={value} />)
        })
    }

    if(bottomvalue){
        bottomvalue.forEach((data, value) => {
            l3.push(<img id={data} src={"/assets/home-goods/images/" + data +".jpg"} alt={data} className='image-slider-auto mx-4' onClick={() => openImageModal(data, bottomvalue)} key={value} />)
        })
    }
   

    useEffect(() => {
        setTopvalue(shuffle(lists(0, 34)))
        setMiddlevalue(shuffle(lists(34, 68)))
        setBottomvalue(shuffle(lists(68, 101)))
    }, [])

  return (
    <>
        <Card className='no-border rounded-0'>
            <Row>
                <Col>
                    <div className="home-goods-parent">
                        <div className="home-goods-child">{l1} </div>
                    </div>

                    <div className="home-goods-parent-middle">
                        <div className="home-goods-child-middle"> {l2} </div>
                    </div>


                    <div className="home-goods-parent">
                        <div className="home-goods-child"> {l3} </div>
                    </div>
                    <ImageViewer 
                    show={modalShow}
                    onHide={() => setModalShow(false)}
                    imagesrc={imageUrl}
                    imagedir="assets/home-goods/images/extended/"
                    imagecounter={100}
                    mimetype="jpg"
                    />
                </Col>
            </Row>
            
        </Card>
        
    </>
  )
}

export default MultiItemSlider
